import { Roles } from 'common/constants/roles';
import { useAuthContext } from 'common/contexts/AuthContext';
import { disableIfMissingAllRoles,disableIfMissingAnyRole } from 'common/utils/DisableButtonEvaluator';

export function usePalmButtonEvaluator(
    allowedRoles: Roles[],
    mustHaveEveryRole = false
) {
    const { currentUserRoles } = useAuthContext();
    const shouldDisableButtons = mustHaveEveryRole
        ? disableIfMissingAllRoles(currentUserRoles, allowedRoles)
        : disableIfMissingAnyRole(currentUserRoles, allowedRoles);
    return shouldDisableButtons;
}
